var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9959 0.350938C13.1691 -0.116979 13.8309 -0.11698 14.0041 0.350937L17.3336 9.34888C17.388 9.49599 17.504 9.61197 17.6511 9.66641L26.6491 12.9959C27.117 13.1691 27.117 13.8309 26.6491 14.0041L17.6511 17.3336C17.504 17.388 17.388 17.504 17.3336 17.6511L14.0041 26.6491C13.8309 27.117 13.1691 27.117 12.9959 26.6491L9.66641 17.6511C9.61197 17.504 9.49599 17.388 9.34888 17.3336L0.350938 14.0041C-0.116979 13.8309 -0.11698 13.1691 0.350937 12.9959L9.34888 9.66641C9.49599 9.61197 9.61197 9.49599 9.66641 9.34888L12.9959 0.350938Z",
    fill: "url(#paint0_linear_152_9480)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_9480",
    x1: 0,
    y1: 13.5,
    x2: 27,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BD5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601667,
    stopColor: "#089A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10469E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar);
export default __webpack_public_path__ + "static/media/hero-star.8cd8598e1c766adc6feea29eee5d2011.svg";
export { ForwardRef as ReactComponent };